import { TOGGLE_MAP, MAP_DATE } from '../actions/map';
export var mapToggled = function mapToggled() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case TOGGLE_MAP:
      return action.toggled;
    case MAP_DATE:
      return true;
    default:
      return state;
  }
};
export var mapDate = function mapDate() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case MAP_DATE:
      return true;
    case TOGGLE_MAP:
      return !action.toggled ? false : state;
    default:
      return state;
  }
};